<div
  class="tag-button modern-tag-button"
  [ngClass]="{
    'ddc-home-card-light-3': _isLightTheme,
    'ddc-home-card-dark-3': _isDarkTheme,
    'ddc-home-card-paper-3': _isPaperTheme,
  }"
  (click)="downloadPDF()"
>
  <div class="button-content">
    <mat-icon class="tag-icon">print</mat-icon>
    <span class="tag-label">{{ pdf.dictionary.title }}</span>
  </div>
</div>
